import { type Common } from './common.js';
import type * as Medication from './models/medication.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  // analyst app endpoints
  async findAllByEhrInformationId(ehrInformationId: string): Promise<Medication.Medication[]> {
    const url = this.common.constructPath(`/medications`, { ehrInformationId });
    return await this.common.getJSON(url);
  }

  // previsit app endpoints
  async findAll(): Promise<Medication.Medication[]> {
    const url = this.common.constructPath(`/patient-previsit/medications`);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Medication.Medication> {
    const url = this.common.constructPath(`/patient-previsit/medications/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: Medication.CreateValues): Promise<Medication.Medication> {
    const url = this.common.constructPath(`/patient-previsit/medications`);
    return await this.common.postJSON(url, values);
  }

  async upsert(values: Omit<Medication.CreateValues, 'source'>): Promise<Medication.Medication> {
    const url = this.common.constructPath(`/patient-previsit/medications`);
    return await this.common.putJSON(url, values);
  }

  async update(id: string, values: Medication.UpdateValues): Promise<Medication.Medication> {
    const url = this.common.constructPath(`/patient-previsit/medications/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<void> {
    const url = this.common.constructPath(`/patient-previsit/medications/${id}`);
    return await this.common.deleteJSON(url);
  }
}
